import React from "react";
import { Typography,Box } from "@mui/material";

function QuestionInfoHeader({ currentQuestion, maximumMark, negativeMark,question }) {
  
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: { xs: "6px 10px", sm: "8px 16px" },
        borderBottom: "1px solid #e0e0e0",
        background: "#f8f9fa",
        flexWrap: "wrap",
        gap: 1,
      }}
    >
      <Typography
        sx={{ fontSize: { xs: "0.82rem", sm: "0.9rem" }, fontWeight: 600, color: "#333" }}
      >
        Question No. {currentQuestion + 1}
      </Typography>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography sx={{ fontSize: { xs: "0.72rem", sm: "0.8rem" }, color: "#555" }}>
            Maximum Mark:{" "}
          </Typography>
          <Box
            sx={{
              px: 1,
              py: "1px",
              color: "green",
              border: "1px solid green",
              borderRadius: "10px",
              backgroundColor: "#d0f0c0",
              fontSize: { xs: "0.72rem", sm: "0.8rem" },
              fontWeight: 600,
              lineHeight: 1.6,
            }}
          >
            {maximumMark || "0.00"}
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <Typography sx={{ fontSize: { xs: "0.72rem", sm: "0.8rem" }, color: "#555" }}>
          Negative Mark:{" "}          </Typography>
          <Box
            sx={{
              px: 1,
              py: "1px",
              color: "red",
              border: "1px solid red",
              borderRadius: "10px",
              backgroundColor: "#ffcdd2",
              fontSize: { xs: "0.72rem", sm: "0.8rem" },
              fontWeight: 600,
              lineHeight: 1.6,
            }}
          >
            {negativeMark || "0.00"}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default QuestionInfoHeader;
